import React from 'react'
import CIcon from '@coreui/icons-react'
import {
  cilBell,
  cilCalculator,
  cilCalendar,
  cilChartPie,
  cilCursor,
  cilDrop,
  cilEnvelopeOpen,
  cilGrid,
  cilLayers,
  cilMap,
  cilNotes,
  cilPencil,
  cilPuzzle,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
} from '@coreui/icons'
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react-pro'

const _navSales = [
  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/dashboard',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    badge: {
      color: 'info-gradient',
    },
  } /*
  {
    component: CNavGroup,
    name: 'Users',
    icon: <CIcon icon={cilPuzzle} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Group Users',
        to: '/linkusers',
      },
    ],
  },*/,
  {
    component: CNavGroup,
    name: 'Payment Links',
    icon: <CIcon icon={cilPuzzle} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'View Payment Ref Link',
        to: '/viewprlink',
        requiredPermission: 'PAYMENTREF',
        requiredPrivilege: 'VIEW',
      },
      {
        component: CNavItem,
        name: 'View Payment Link',
        to: '/viewpaymentlink',
        requiredPermission: 'PAYMENTLINK',
        requiredPrivilege: 'VIEW',
      } /*
      {
        component: CNavItem,
        name: 'Create Payment Link',
        to: '/generatelink',
      },*/,
      ,
    ],
  },
  {
    component: CNavItem,
    name: 'Log out',
    to: '/logout',
    icon: <CIcon icon={cilDrop} customClassName="nav-icon" />,
  },
]

export default _navSales
